import { FC } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import gql from 'graphql-tag'
import { useRouter } from 'next/router'
import {
  CoverLetterItemScreen_CurrentUserFragment,
  CoverLetterItemScreen_CoverLetterFragment,
} from 'generated/graphql'
import PageLayout, { RenderComponentType } from 'components/PageLayout'
import { MOBILE_BUTTON_SIZE } from 'constants/paginations'
import {
  SearchStateContextProvider,
  UseSearchStateProps,
} from 'screens/CoverLetterScreen/useSearchState'
import { IE11 } from 'style/mediaQuery'
import CoverLetterItemMain from './CoverLetterItemMain'

const useStyles = makeStyles((theme) => ({
  simplePageLayoutRoot: {
    [IE11]: {
      overflowY: 'auto',
    },
  },
  pageLayoutContainer: {
    paddingTop: '60px',
    paddingBottom: 0,
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0,
    },
  },
  footer: {
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 60,
    },
  },
  pageLoading: {
    display: 'flex',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
}))

interface CoverLetterItemScreenProps extends UseSearchStateProps {
  currentUser?: CoverLetterItemScreen_CurrentUserFragment | null
  coverLetter?: CoverLetterItemScreen_CoverLetterFragment | null
  highlight?: string[] | null | undefined
  renderComponents?: RenderComponentType[]
}

const CoverLetterItemScreen: FC<CoverLetterItemScreenProps> = ({
  currentUser,
  coverLetter,
  highlight,
  searchState,
  onSearchStateChange,
  renderComponents,
}) => {
  const classes = useStyles()
  const router = useRouter()

  const isSimplePage = Boolean(router?.query?.simple)

  const pageLayoutRenderComponents: RenderComponentType[] = [
    'Header',
    'InternalNavBar',
    'MobileNavTab',
  ]

  return (
    <PageLayout
      classes={{
        root: clsx({ [classes.simplePageLayoutRoot]: isSimplePage }),
      }}
      isNavBarSticky={true}
      renderComponents={renderComponents ?? pageLayoutRenderComponents}
      FooterProps={{ className: classes.footer }}
      ContainerProps={{
        className: classes.pageLayoutContainer,
        maxWidth: false,
        disableGutters: true,
      }}
    >
      <SearchStateContextProvider
        searchState={searchState}
        onSearchStateChange={onSearchStateChange}
        paginationMaxButtons={MOBILE_BUTTON_SIZE}
      >
        <CoverLetterItemMain
          coverLetter={coverLetter}
          highlight={highlight}
          currentUser={currentUser}
        />
      </SearchStateContextProvider>
    </PageLayout>
  )
}

export default CoverLetterItemScreen

gql`
  fragment CoverLetterItemScreen_currentUser on User {
    id
    ...CoverLetterItemMain_currentUser
  }
  fragment CoverLetterItemScreen_coverLetter on CoverLetter {
    id
    ...CoverLetterItemMain_coverLetter
  }
`
